module.exports = __webpack_public_path__ + "static/media/banner_front.7a4dea39.png";